import {
    createAttemptApi,
    getAttemptHistoryByUserIdApi,
    getExamDetailForCandidateApi,
    getExamsByUserIdApi,
    getExamAssignmentApi,
    getAttemptApi,
    submitAttemptApi,
    getQuestionPreviewApi,
    getAttributeFeedbackApi,
} from 'HTTPClients/exams.client'
import { GetQuestionFeedbackResponseType } from 'Types/Exams.types'
import { sanitizeAxiosError } from 'Utils/common.utils'

export const getExamsByUserId = async (userId: string) => {
    const resp = await getExamsByUserIdApi(userId)
    if (!resp.isOk()) {
        throw new Error(sanitizeAxiosError(resp.error) ?? 'Failed to get exams')
    }
    return resp.value
}

export const getExamDetailForCandidate = async ({
    userId,
    examId,
}: {
    userId: string
    examId: string
}) => {
    const resp = await getExamDetailForCandidateApi(userId, examId)
    if (!resp.isOk()) {
        throw new Error(sanitizeAxiosError(resp.error) ?? 'Failed to get exam detail')
    }
    return resp.value
}

export const getAttemptHistoryByUserId = async (userId: string) => {
    const resp = await getAttemptHistoryByUserIdApi(userId)
    if (!resp.isOk()) {
        throw new Error(sanitizeAxiosError(resp.error) ?? 'Failed to get attempt history')
    }
    return resp.value
}

export const createAttempt = async ({ userId, examId }: { userId: string; examId: string }) => {
    const resp = await createAttemptApi(userId, examId)
    if (!resp.isOk()) {
        throw new Error(sanitizeAxiosError(resp.error) ?? 'Failed to create attempt')
    }
    return resp.value
}

export const getAttempt = async (attemptId: string) => {
    const resp = await getAttemptApi(attemptId)
    if (!resp.isOk()) {
        throw new Error(sanitizeAxiosError(resp.error) ?? 'Failed to resume attempt')
    }
    return resp.value
}

export const submitAttempt = async (attemptId: string) => {
    const resp = await submitAttemptApi(attemptId)
    if (!resp.isOk()) {
        throw new Error(sanitizeAxiosError(resp.error) ?? 'Failed to submit attempt')
    }
    return resp.value
}

export const getExamAssignment = async ({
    answerId,
    userId,
}: {
    answerId: string
    userId: string
}) => {
    const resp = await getExamAssignmentApi(answerId, userId)
    if (!resp.isOk()) {
        throw new Error(sanitizeAxiosError(resp.error) ?? 'Failed to get question')
    }
    return resp.value
}

export const getQuestionPreview = async ({
    questionVersionId,
    examVersionId,
    questionsetVersionId,
}: {
    questionVersionId: string
    examVersionId: string
    questionsetVersionId: string
}) => {
    const resp = await getQuestionPreviewApi({
        questionVersionId,
        examVersionId,
        questionsetVersionId,
    })
    if (!resp.isOk()) {
        throw new Error(sanitizeAxiosError(resp.error) ?? 'Failed to get question preview')
    }
    return resp.value
}

export const getAttributeFeedback = async (
    answerId: string
): Promise<GetQuestionFeedbackResponseType> => {
    const resp = await getAttributeFeedbackApi(answerId)
    if (!resp.isOk()) {
        throw new Error(sanitizeAxiosError(resp.error) ?? 'Failed to get question feedback')
    }
    return resp.value
}
